import { RootState } from '@atredux/store'
import { IAwsCredentials } from '@atredux/slices/userRoleSlice'

export const getRoleCredentialPromise = (state: RootState, role: string): Promise<IAwsCredentials> | undefined =>
    state.userRole._roleToCredentialPromises[role]
